import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Breadcrumbs from '../../common/Breadcrumbs';
import { removeTasksWithIds } from '../../api/tasks';
import Table from '../../сomponents/Table';
import { path } from 'ramda';
import {
  fetchAllTasks,
  getDetailProjectTask,
} from '../../api/dashboard';

import { fetchProjectById, removeProjectById } from '../../api/projects';
import CheckBox from "../../common/CheckBox";
import { deleteObject } from "../../actions/objectToDelete";
import { changeModalState } from "../../actions/modal";
import ConfirmAction from '../../common/ConfirmAction';

import "./style.css";
import { fetchQuoteByIdWithRole } from "../../api/quotes";
import hasAccess from "../../helpers/permissionChecker";

let pid;

class QuotesWO extends Component {

  constructor(props) {
    super(props);

    this.state = {
      id: null,
      items: Array.from([]),
      container: false,
      search: '',
      itemsPerPage: 10,
      projectTasks: Array.from([]),
      selected: [],
      currentPage: 0,
    };

    this.columns = [
      'content',
      'description',
    ];

    this.columnNames = [
      'Task Name',
      'Description',
    ];

    this.onSearch = this.onSearch.bind(this);
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
    this.handlerEdit = this.handlerEdit.bind(this);
    this.loadData = this.loadData.bind(this);
    this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    const id = path(['match', 'params', 'id'], this.props);
    pid = id;
    // this.props.getTasks(id);
    this.props.getCurrentQuote(id);
    this.props.getDashboardTasks();
    this.setState({
      id,
    });
  }

  componentWillReceiveProps(nextProps) {
    const projectTasks = path(['dashboard', 'projectTasks'], nextProps) || [];

    if (projectTasks.length > 0) {
      this.setState({
        projectTasks,
      });
    }
  }

  onSearch(e) {
    e.preventDefault();
    this.setState({
      search: e.target.value,
    });
    return false;
  }

  onChangeCurrentPage(currentPage) {
    this.setState({
      currentPage: currentPage,
    });
  }

  onChangeItemsPerPage(e) {
    e.preventDefault();
    this.setState({
      itemsPerPage: e.target.value,
    });
    return false;
  }

  wrapTasksContentWithCheckbox = (tasks = []) => {
    return tasks.map(task => ({ ...task, content: this.checkBoxTask(task) }));
  };

  checkBoxTask = (task) => {
    if (hasAccess({ 'permAreaKey': 'workOrder', 'permTypeKey': 'delete', 'idForCheckingAuthor': task.user_id })) {
      return (
        <CheckBox
          field={{ name: 'tasks', value: this.state.selected.includes(task.id), label: task.content }}
          onChange={this.changeTaskSelection(task.id)}
          customize={{ marginBottom: 0 }}
          className="checkbox-task"
          key={task.id}
        />
      )
    } else {
      return (<div key={task.id}>{task.content}</div>)
    }
  };

  changeTaskSelection = id => () => {
    const { selected } = this.state;
    if (selected.includes(id)) this.setState(state => (
      {
        ...state,
        selected: state.selected.filter(item => item !== id)
      }
    ));
    else this.setState(state => ({ ...state, selected: [...state.selected, id] }));
  };

  handlerEdit = (name) => (id) => {
    this.props.openTask(name, id);
  }

  handlerDelete = () => {
    this.props.handleObjectToDelete({
      id: this.state.selected,
      handler: removeTasksWithIds,
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'removeTasksWithIds',
    });

  }

  onCancelSelection = () => {
    this.setState(state => ({ ...state, selected: [] }));
  };

  render() {
    const tasks = path(['dashboard', 'projectTasks'], this.props) || []

    const quotesTasksWithWrapper = this.wrapTasksContentWithCheckbox(tasks);

    const currentQuoteName = path(['quotes', 'quote', 'quote', 'name'], this.props);
    const itemActions = {
      edit: {
        handler: this.handlerEdit(currentQuoteName),
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-pencil icon-stack-1x'],
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'edit',
      }
    };

    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { url: '/pages/quotes', icon: 'format_quote', name: 'Quotes' },
          { icon: 'chrome_reader_mode', name: currentQuoteName },
        ]}/>
        <div className="card rounded">
          <div className="card-header rounded-top">
            List of tasks for ({currentQuoteName}) <br/>
          </div>
          <div className="clearfix ml-4 mt-3">
            <small>Click on the work order name/s that you wish to delete, then click Delete.</small>
            <div className="float-right mr-4">
              {hasAccess({ 'permAreaKey': 'workOrder', 'permTypeKey': 'delete' }) &&
              <button
                className={'btn btn-info btn-outline'}
                style={{ marginLeft: '10px' }}
                onClick={this.handlerDelete}
              >
                <i className="fa fa-trash"></i>
                <span style={{ paddingLeft: '3px' }}>Delete</span>
              </button>
              }
              <button
                className={'btn btn-danger btn-outline'}
                style={{ marginLeft: '10px' }}
                onClick={this.onCancelSelection}
              >
                <i className="fa fa-remove"></i>
                <span style={{ paddingLeft: '3px' }}>Cancel</span>
              </button>
            </div>
          </div>
          <div className="card-block" id="quotes-wo">
            {quotesTasksWithWrapper && <Table
              items={quotesTasksWithWrapper}
              itemsForSortingFiltering={tasks}
              columns={this.columns}
              columnNames={this.columnNames}
              itemsPerPage={this.state.itemsPerPage}
              search={this.state.search}
              currentPage={this.state.currentPage}
              onChangeCurrentPage={this.onChangeCurrentPage}
              actions={itemActions}
              onSearch={this.onSearch}
              onChangeItemsPerPage={this.onChangeItemsPerPage}
            />}
            <ConfirmAction id={'removeTasksWithIds'} content="Are you sure you want to delete selected item/s?"/>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDashboardTasks: () => {
      fetchAllTasks()(dispatch);
    },
    getTasks: (id) => {
      getDetailProjectTask(id)(dispatch);
    },
    getCurrentQuote: (id) => {
      fetchQuoteByIdWithRole(id)(dispatch);
    },
    openTask: (name, tid) => {
      localStorage.setItem('cameToWOFrom', 'quotes-wo');
      localStorage.setItem('lastQuotesWoName', name);
      dispatch(push(`/pages/task/${tid}`));
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    handleObjectToDelete: (data) => {
      dispatch(deleteObject(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuotesWO);



// WEBPACK FOOTER //
// ./src/containers/QuotesWO/index.js